<mbs-card-group>
  <ng-container *ngTemplateOutlet="credentialsTmp"></ng-container>
</mbs-card-group>
@if (authType === AuthType.Legacy && storageType === StorageType.AmazonS3) {
  <mbs-card-group>
    <ng-container *ngTemplateOutlet="govCloudTmp"></ng-container>
  </mbs-card-group>
}

<ng-template #credentialsTmp>
  <mbs-form-group>
    <mbs-select
      [attr.data-e2e]="e2eLocators.storageType"
      [bindLabel]="'name'"
      [bindValue]="'type'"
      [boldLabel]="true"
      [clearable]="false"
      [formControl]="storageTypeControl"
      [items]="awsStorageType"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.storageType' | i18next">
    </mbs-select>
  </mbs-form-group>

  @if (storageType !== StorageType.AmazonS3Chinese) {
    <mbs-form-group>
      <mbs-select
        [attr.data-e2e]="e2eLocators.authType"
        [bindLabel]="'label'"
        [bindValue]="'value'"
        [boldLabel]="true"
        [clearable]="false"
        [formControl]="authTypeControl"
        [hint]="hint"
        [items]="authTypes"
        [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.authenticationType' | i18next">
        <ng-template #hint>
          <span [innerHTML]="AuthTypeHints[authType] | i18next | safe: 'html'"></span>
          @if (authType === AuthType.Legacy && PermissionEnum.HelpMarketing | can: 'read') {
            <span
              [innerHTML]="
                'storages:addStorageAccountWizard.inputCredentialsStep.authTypeLegacyHintHelpLink'
                  | i18next: { helpLink: '/billing-storage/storage-providers/amazon/iam-user-account' | helpLink }
                  | safe: 'html'
              "></span>
          }
          @if (authType === AuthType.MBS) {
            <mbs-button
              [attr.data-e2e]="e2eLocators.minimumRequiredPermissionsBtn"
              [isCtrl]="true"
              [size]="mbsSize.sm"
              (click)="openMinimumRequiredPermissionsModal()">
              {{ 'storages:addStorageAccountWizard.inputCredentialsStep.minimumRequiredPermissions' | i18next }}
            </mbs-button>
          }
        </ng-template>
      </mbs-select>
    </mbs-form-group>
  }

  @if (authType === AuthType.MBS || authType === AuthType.Legacy) {
    <mbs-form-group>
      <mbs-input
        [attr.data-e2e]="e2eLocators.accessKey"
        [autocomplete]="'new-password'"
        [boldLabel]="true"
        [formControl]="accessKeyControl"
        [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.accessKey' | i18next"
        [placeholder]="'storages:addStorageAccountWizard.inputCredentialsStep.placeholders.accessKey' | i18next"
        [showRequiredMark]="false"></mbs-input>
    </mbs-form-group>
    <mbs-form-group>
      <mbs-input-password
        [attr.data-e2e]="e2eLocators.secretKey"
        [autocomplete]="'new-password'"
        [boldLabel]="true"
        [disabledEye]="secretKeyControl.value === fakeSecretKey"
        [formControl]="secretKeyControl"
        [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.secretKey' | i18next"
        [placeholder]="'storages:addStorageAccountWizard.inputCredentialsStep.placeholders.secretKey' | i18next"
        [showRequiredMark]="false"></mbs-input-password>
    </mbs-form-group>
  }

  @if (authType === AuthType.Manual) {
    <mbs-form-group>
      <mbs-input-label
        [boldLabel]="true"
        [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.providerID' | i18next"></mbs-input-label>
      <span
        class="fa fa-info-circle text-info text-lg ml-2 mr-1"
        container="body"
        [ngbTooltip]="'storages:addStorageAccountWizard.inputCredentialsStep.providerIdTooltip' | i18next"
        [placement]="'top'"
        [tooltipClass]="'text-left'"></span>
      @if (id; as id) {
        <mbs-clipboard [content]="id" />
      }
    </mbs-form-group>
    <mbs-form-group>
      <mbs-input
        [attr.data-e2e]="e2eLocators.arnRole"
        [boldLabel]="true"
        [formControl]="arnRoleControl"
        [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.roleARN' | i18next"
        [placeholder]="'storages:addStorageAccountWizard.inputCredentialsStep.placeholders.roleARN' | i18next"
        [showRequiredMark]="false"></mbs-input>
    </mbs-form-group>
  }
</ng-template>

<ng-template #govCloudTmp>
  <mbs-switcher
    class="text-base"
    [attr.data-e2e]="e2eLocators.isGov"
    [boldLabel]="true"
    [expandLabel]="true"
    [formControl]="isGovControl"
    [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.govCloudAccount' | i18next"
    [labelPosition]="'left'"></mbs-switcher>
</ng-template>
